import { BaseApiService } from '@shared/services/BaseApiService';
import { isID } from '@shared/helpers/uid';
import { EntryPointBackend } from '@autoinformer/models/worksheet-actions/backend/entry-point';

class WorksheetEntryServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  createItem(worksheet_id, params) {
    return this.http
      .post(`/${worksheet_id}/actions`, params)
      .then(item => new EntryPointBackend(item).toFrontend());
  }

  updateItem(worksheet_id, id, params) {
    return (
      this.http
        .put(`/${worksheet_id}/actions/${id}`, params)
        .then((item) => new EntryPointBackend(item).toFrontend())
    );
  }

  removeItem(worksheet_id, id) {
    return this.http.delete(`/${worksheet_id}/actions/${id}`);
  }

  createOrUpdateItem(worksheet_id, id, params) {
    if (isID(id)) {
      return this.updateItem(worksheet_id, id, params);
    } else {
      return this.createItem(worksheet_id, params);
    }
  }
}

export const WorksheetEntryService = new WorksheetEntryServiceClass({
  api_version: 2,
  resource: 'informer/campaigns'
});
